import { AdminSettingTypes as Type } from '../../../types/adminsetting';

const initialState = {
  newAdmin: null,
  loading: false,
  error: null,
};

const AddNewAdminReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case Type.ADD_NEW_ADMIN_REQUEST:
      return { ...state, loading: true, error: null, newAdmin: null };
    case Type.ADD_NEW_ADMIN_REQUEST_SUCCESS:
      return {
        ...state,
        newAdmin: action.payload,
        loading: false,
      };
    case Type.ADD_NEW_ADMIN_REQUEST_FAILURE:
      return { ...state, error: action.error, loading: false };
      case Type.RESET_ADD_ADMIN_STATE:
        return { ...initialState };
    default:
      return state;
  }
};

export default AddNewAdminReducer;